import { type ComponentProps, memo } from 'react';

import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

export const assetModalContentFooterColumn = tailwindVariants({
  base: 'flex items-center gap-2',
  defaultVariants: {
    side: 'center',
  },
  variants: {
    side: {
      center: '',
      left: 'flex-1 justify-start',
      right: 'flex-1 justify-end',
    },
  },
});

export type AssetModalContentFooterColumnVariants = VariantProps<typeof assetModalContentFooterColumn>;

export type AssetModalContentFooterColumnProps = ComponentProps<'div'> &
  Required<AssetModalContentFooterColumnVariants>;

export const AssetModalContentFooterColumn = memo(
  ({ className, side, ...restOfProps }: AssetModalContentFooterColumnProps) => {
    return (
      <div
        className={assetModalContentFooterColumn({ side, className })}
        data-side={side}
        data-testid="ASSET_MODAL_CONTENT_FOOTER_COLUMN"
        {...restOfProps}
      />
    );
  },
);

AssetModalContentFooterColumn.displayName = 'AssetModalContentFooterColumn';
